import { IColuna } from "app/types/IColuna";
import React, { useContext } from "react";
import { EstilosIndividuaisNomeColunasMarkup } from "../EstilosIndividuaisNomeColunasMarkup";
import { traduzirNomeColunaMarkup } from "./TraduzirNomeColunaMarkup";
import { TelaMarkupContext } from "../../TelaMarkup";

export type HeadGridMarkupProps = {
  colunas: IColuna[];
};

export const HeadGridMarkup = (props: HeadGridMarkupProps) => {
  const contexto = useContext(TelaMarkupContext)
  return (
    <thead>
      <tr>
        {props.colunas.map(
          (coluna, key) =>
            coluna.Selecionada && (
              <th
                key={key}
                style={{whiteSpace: 'normal', ...EstilosIndividuaisNomeColunasMarkup(coluna.Nome)}}
                id={`GridMarkup_Cabecalho_${coluna.Nome.replace(/\s+/g, '_')}_${key}`}
              >
                {traduzirNomeColunaMarkup({ nomeColuna: coluna.Nome, exibirNomeReferencia: contexto.exibirNomeReferencia })}
                {coluna.Selecionada}
              </th>
            )
        )}
      </tr>
    </thead>
  );
};
